import { TenantOrderLine } from '~/lib/model';
import { Big } from 'big.js';
import TwtJob from '../../model/TwtJob';
import { schema_latest_version, ZodVersionedMetadata } from '~/lib/zod';
import { PersonaType } from '~/tenants/common/TenantPersona';
import TwtNucleusVideoConfig from './TwtNucleusVideoConfig';
import { DeliverableType } from '~common/model/Deliverable';
import { TwtOrderType } from '~/tenants/twt/model/enums';
import { Duration } from 'luxon';

export const TWT_NUCLEUS_VIDEO_PRICE = 99;

export class TwtNucleusVideoJob extends TwtJob<typeof TwtNucleusVideoConfig> {
  get performable() {
    return TwtNucleusVideoConfig;
  }

  get deliverable(): DeliverableType {
    return DeliverableType.SOCIAL;
  }

  get dependencies() {
    return [TwtNucleusVideoConfig.id];
  }

  defaultValue(): ZodVersionedMetadata<(typeof TwtNucleusVideoConfig)['schema']> {
    return {
      version: schema_latest_version(TwtNucleusVideoConfig.schema),
    } as any;
  }

  get eligible() {
    return (
      this.order.metadata.type === TwtOrderType.FOR_SALE_LISTING &&
      this.order.jobs.some((j) => j.performable_id === 'nucleus')
    );
  }

  get configurable() {
    return false;
  }

  get startWithin(): Duration | null {
    return Duration.fromObject({ days: 1 });
  }

  get completeWithin(): Duration | null {
    return Duration.fromObject({ days: 2 });
  }

  get media() {
    return PersonaType.OFFICE;
  }

  revenueLines(): TenantOrderLine[] {
    return [
      {
        amount: new Big(TWT_NUCLEUS_VIDEO_PRICE),
        taxable: true,
        description: 'Nucleus Video',
        id: 'video',
      },
    ];
  }
}
